<template>
    <div>
        <HeaderSection icon="fas fa-user-plus" title="Edición de Usuario">
            <template slot="buttons">
                <el-tooltip class="item" effect="dark" content="Regresar" placement="top-end">
                    <el-button
                        size="medium"
                        type="danger"
                        icon="el-icon-arrow-left"
                        @click="$router.push('/administracion/usuarios')">
                    </el-button>
                </el-tooltip>
            </template>
        </HeaderSection>
        <el-form ref="user-form" :model="userForm" label-width="120px" label-position="top">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item
                        label="Tipo de usuario"
                        prop="isLdap"
                        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                        <el-switch
                            @change="checkIsLdap"
                            v-model="userForm.isLdap"
                            active-text="Interno"
                            inactive-color="#13322B"
                            active-color="#9d2438"
                            inactive-text="Externo">
                        </el-switch>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item
                        label="Usuario"
                        prop="username"
                        :rules="[
                                 { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
                                 { pattern:/^[ña-z-ú_]+?$/, message: 'Ingrese sólo letras minúsculas' }
                                ]">
                        <el-input v-my-only-alphanumeric="{maxChars: 70}" v-model="userForm.username" @change="checkUser(userForm.username, userForm.isLdap)" :disabled="userForm.isLdap"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item
                        label="Correo electrónico"
                        prop="email"
                        :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                { type: 'email', message: 'Introduzca un correo valido', trigger: 'blur' },
                                { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' }]">
                        <el-input v-my-only-alphanumeric="{maxChars: 70}" :disabled="userForm.isLdap" v-model="userForm.email"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item
                        label="Apellido Paterno"
                        prop="firstName"
                        :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' },
                                    {pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}]">

                        <el-input v-my-only-alphanumeric="{maxChars: 70}" :disabled="userForm.isLdap" v-model="userForm.firstName" class="input-with-select">
                            <el-select class="el-select-custom"
                                       v-model="userForm.cat_user_prefix_id"
                                       slot="prepend"
                                       placeholder="tít.">
                                <el-option
                                    v-for="prefix in prefixes"
                                    :key="prefix.id"
                                    :label="prefix.name"
                                    :value="prefix.id">
                                </el-option>
                            </el-select>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Apellido Materno"
                                  :rules="{pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}">
                        <el-input v-my-only-alphanumeric="{maxChars: 70}" :disabled="userForm.isLdap" v-model="userForm.secondName"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item
                        label="Nombre(s)"
                        prop="name"
                        :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' },
                                    {pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}]">

                        <el-input v-my-only-alphanumeric="{maxChars: 70}" :disabled="userForm.isLdap" v-model="userForm.name"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item
                        label="Oficina"
                        prop="cat_office_id"
                        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                        <el-select
                            v-model="userForm.cat_office_id"
                            filterable
                            clearable
                            placeholder="Seleccionar"
                            style="width: 100% !important;">
                            <el-option
                                v-for="office in offices"
                                :key="office.id"
                                :label="office.name"
                                :value="office.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item
                        label="Perfil"
                        prop="cat_profile_id"
                        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                        <el-select
                            v-model="userForm.cat_profile_id"
                            filterable
                            @change="setUserRoles(userForm.cat_profile_id)"
                            placeholder="Seleccionar"
                            style="width: 100%">
                            <el-option
                                v-for="profile in profiles"
                                :key="profile.id"
                                :label="profile.name"
                                :value="profile.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8" v-if="!userForm.isLdap">
                    <el-form-item
                        label="Usuario Extranjero"
                        prop="isLdap"
                        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                        <el-switch

                            v-model="userForm.isForeign"
                            active-text="Extranjero"
                            inactive-color="#13322B"
                            active-color="#9d2438"
                            inactive-text="Nacional">
                        </el-switch>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item
                        label="Signatario"
                        prop="isLdap"
                        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                        <el-switch
                            v-model="userForm.isSignatory"
                            active-text="Sí"
                            inactive-color="#13322B"
                            active-color="#9d2438"
                            inactive-text="No">
                        </el-switch>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Cargo"
                                  prop="charge"
                                  :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' },
                                    {pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}]">
                        <el-input v-my-only-alphanumeric="{maxChars: 70}" v-model="userForm.charge"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24" v-if="userForm.cat_profile_id == 5">
                    <el-form-item label="Banco"
                                  prop="cat_bank_id"
                                  :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                        <el-select
                            v-model="userForm.cat_bank_id"
                            filterable
                            placeholder="Seleccionar"
                            style="width: 100%">
                            <el-option
                                v-for="bank in banks"
                                :key="bank.id"
                                :label="bank.name"
                                :value="bank.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                </el-col>
                <el-col :span="24" v-if="userForm.cat_profile_id == 6">
                    <el-form-item label="No. de Corredor Público"
                                  prop="publicHallNumber"
                                  :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' },
                                    {pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}]">
                        <el-input v-my-only-alphanumeric="{maxChars: 70}" v-model="userForm.publicHallNumber"/>
                    </el-form-item>

                </el-col>
                <el-col :span="24" v-if="userForm.cat_profile_id == 7">
                    <el-form-item label="Notaria"
                                  prop="cat_notary_id"
                                  :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                        <el-select
                            v-model="userForm.cat_notary_id"
                            filterable
                            placeholder="Seleccionar"
                            style="width: 100%">
                            <el-option
                                v-for="notary in notaries"
                                :key="notary.id"
                                :label="notary.name && notary.state && notary.state.name ?
                                    notary.name +' '+notary.state.name : notary.name"
                                :value="notary.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                </el-col>
            </el-row>
            <!--<el-row :gutter="20" v-if="!userForm.isLdap">
                <el-col :span="12">
                    <el-form-item
                        label="Contraseña"
                        prop="password"
                        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                        <template>
                            <password style="background-color: #ffffff !important;" :badge="false"
                                      v-model="userForm.password"/>
                        </template>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="Repetir contraseña"
                        prop="passwordConfirm"
                        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' }">
                        <el-input
                            v-model="userForm.passwordConfirm"
                            type="password"
                            @change="checkPassword(userForm.password, userForm.passwordConfirm)"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>-->
            <br>
            <el-row class="custom-header" type="flex" justify="space-between">
                <el-col>
                    <h3 class="custom-title">
                        <i class="fas fa-lock"></i>
                        Permisos
                    </h3>
                </el-col>
            </el-row>
            <br>
            <el-row :gutter="20">
                <el-col :span="8">
                    <a href=""
                       style="text-decoration: none"
                       @click.prevent="openPermission('Módulo de Administración', 1)">
                        <el-card style="background: #9d2438; color: whitesmoke; text-align: center">
                            Módulo de Administración
                        </el-card>
                    </a>
                </el-col>
                <el-col :span="8">
                    <a href=""
                       style="text-decoration: none"
                       @click.prevent="openPermission('SIPAC27', 2)">
                        <el-card style="background: #13322B; color: whitesmoke; text-align: center">
                            SIPAC27
                        </el-card>
                    </a>
                </el-col>
                <el-col :span="8">
                    <a href=""
                       style="text-decoration: none"
                       @click.prevent="openPermission('Documentación', 3)">
                        <el-card style="background: #898989; color: whitesmoke; text-align: center">
                            Documentación
                        </el-card>
                    </a>
                </el-col>
            </el-row>
            <br>
            <el-row :gutter="20">
                <el-col :span="24" align="end">
                    <el-button
                        size="medium"
                        type="danger"
                        icon="el-icon-arrow-left"
                        @click="$router.push('/administracion/usuarios')">
                        Cancelar
                    </el-button>
                    <el-button
                        v-if="!userForm.isApproved"
                        size="medium"
                        type="warning"
                        plain
                        icon="fas fa-eye"
                        @click="approvedAux(userForm.cat_profile_id)">
                        Pendiente de autorizar
                    </el-button>
                    <el-button
                        v-if="!userForm.isLdap"
                        size="medium"
                        type="info"
                        plain icon="fas fa-sync-alt" @click="passwordRefresh()">
                        Restablecer Contraseña
                    </el-button>
                    <el-button
                        type="primary"
                        size="medium"
                        icon="far fa-save"
                        @click="submitForm('user-form')">
                        Guardar
                    </el-button>
                </el-col>
            </el-row>
        </el-form>

        <el-dialog title="Validando solicitud"
                   :visible.sync="showApprovedModal"
                   :close-on-press-escape="false"
                   :close-on-click-modal="false">
            <el-form :model="approvedForm" ref="approvedForm" label-width="100px" label-position="top">
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="Estatus"
                                      prop="status"
                                      :rules="{ required: true, message: 'El campo es requerido', trigger: 'change' }">
                            <el-select
                                v-model="approvedForm.status"
                                style="width: 100%"
                                placeholder="Seleccionar">
                                <el-option
                                    v-for="approved in approvedStatus"
                                    :key="approved.id"
                                    :label="approved.name"
                                    :value="approved.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="approvedForm.status == 2">
                        <el-form-item label="Comentarios">
                            <el-input v-my-only-alphanumeric="{maxChars: 250}" v-model="approvedForm.comments" type="textarea" resize="none" :rows="5"/>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="success" plain @click="approvedUser">
                    Aceptar
                </el-button>
                <el-button @click="showApprovedModal = false">
                    Cancelar
                </el-button>
            </span>


        </el-dialog>


        <Permissions
            :title="title"
            :showDialog="showPermissions"
            :system="system"
            :userRoles="userRoles"
            @save-permissions="setPermissionsBy(...arguments)"
            @close-dialog="showPermissions = false"/>
    </div>
</template>

<script>
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
    import HeaderSection from '../../../partials/HeaderSection';
    import password from 'vue-password-strength-meter'
    import Permissions from './partials/Permissions';

    export default {
        components: {
            HeaderSection,
            password,
            Permissions
        },

        computed: {
            userInfo() {
                return this.$store.state.user;
            },
            ...mapGetters('utils', {
                userRequest: "userRequest",
            }),

        },

        created() {
            let cryptId = this.$route.params.id;
            this.showLoading();
            axios.get(`/api/users/${cryptId}/edit`).then(response => {

                this.profiles = response.data.profiles;
                this.offices = response.data.offices;
                this.isLdap = response.data.isLdap;
                this.prefixes = response.data.prefixes;
                this.banks = response.data.banks;
                this.notaries = response.data.notaries;
                this.userRoles = response.data.form.roles.map(up => up.id);
                this.AdministratorPermissions = response.data.form.roles.filter(up => up.system == 1)
                    ? response.data.form.roles.filter(up => up.system == 1).map(up => up.id) : [];
                this.SpcPermissions = response.data.form.roles.filter(up => up.system == 2)
                    ? response.data.form.roles.filter(up => up.system == 2).map(up => up.id) : [];
                this.userForm = response.data.form;
                this.hideLoading();
            }).catch(error => {
                console.log('created', error);
                this.hideLoading();

                this.$notify({
                    type: 'error',
                    message: 'No se pudo completar la acción'
                });
            });
        },

        data() {
            return {
                isLdap: true,
                username: '',
                offices: [],
                profiles: [],
                banks: [],
                notaries: [],
                userForm: {
                    permissions: [],
                },
                permissions: [],
                approvedForm: {},
                title: '',
                showPermissions: false,
                system: 1,
                userRoles: [],
                AdministratorPermissions: [],
                SpcPermissions: [],
                prefixes: [],
                showApprovedModal: false,
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                approvedStatus: [
                    {
                        'id': 1,
                        'name': 'Aprobada'
                    },
                    {
                        'id': 2,
                        'name': 'Rechazada'
                    },
                ]
            };
        },

        methods: {
            setUserRoles(profile) {
                this.userRoles = [];
                this.$store.dispatch(
                    'loading/spinner',
                    {msg: 'Asignando permisos...', status: true},
                    {root: true}
                );
                axios.get('/api/get-permission', {params: {cat_profile_id: profile}}).then(response => {
                    if (response.data.success) {
                        this.userRoles = response.data.distribution;
                    }
                    this.hideLoading();
                }).catch(error => {
                    this.hideLoading();
                    console.log('setUserRoles', error);
                    this.$notify({
                        type: 'error',
                        message: 'No se pudo completar la acción'
                    });
                });
                return this.userRoles
            },

            showLoading() {
                this.$store.dispatch('loading/spinner', {msg: 'Cargando Datos...', status: true}, {root: true});
            },
            hideLoading() {
                this.$store.dispatch('loading/spinner', {}, {root: true});
            },

            openPermission(title, system) {
                this.title = title;
                this.system = system;
                this.showPermissions = true;
            },

            checkPassword(pass, confirmPass) {

                if (pass !== confirmPass) {
                    this.$notify({
                        type: 'warning',
                        title: 'Contraseña',
                        message: 'La contraseña no coincide, intente de nuevo.'
                    });
                }
            },

            setPermissionsBy(system, permissions) {
                if (system === 1) {
                    this.AdministratorPermissions = permissions;
                    this.userRoles = this.SpcPermissions;
                    this.userRoles.push(...permissions);
                } else if (system === 2) {
                    this.SpcPermissions = permissions;
                    this.userRoles = this.AdministratorPermissions;
                    this.userRoles.push(...permissions);
                }
            },

            submitForm(formName) {

                if (this.userForm.password !== this.userForm.passwordConfirm) {
                    this.$notify({
                        type: 'warning',
                        title: 'Contraseña',
                        message: 'La contraseña no coincide, intente de nuevo.'
                    });

                    return false
                } else {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            this.showLoading();
                            this.userForm.permissions = [
                                ...this.$refs[formName].$options.parent.userRoles
                            ];
                            this.userForm.documents = this.userRequest.documents;
                            axios.put(`/api/users/${this.$route.params.id}`, this.userForm).then(response => {

                                this.$notify({
                                    type: 'success',
                                    title: 'Éxito',
                                    message: response.data.message
                                });
                                if (response.data.userStore) {
                                    this.$store.commit('setUser', response.data.userStore);
                                }
                                this.$router.push('/administracion/usuarios');
                                this.hideLoading();
                            }).catch(error => {
                                this.hideLoading();
                                console.log('error submitForm', error)
                                this.$notify({
                                    type: 'error',
                                    title: 'Error',
                                    message: 'No fue posible registrar al usuario, inténtelo nuevamente.'
                                });
                            });

                        } else {
                            this.$notify({
                                type: 'warning',
                                title: 'Campos Requeridos',
                                message: 'Por favor complete todos los campos requeridos.'
                            });

                            return false;
                        }
                    });
                }
            },

            approvedUser() {
                if (this.userForm && !this.userForm.isLadp && !this.userForm.isApproved) {
                    this.$refs['approvedForm'].validate((valid) => {
                        if (valid) {
                            let _params = {
                                user: this.userForm.hash_id,
                                form: this.approvedForm,
                                permissions: this.userRoles
                            };
                            this.showLoading();
                            axios.post('/api/approved-user', _params).then(response => {
                                if (response.data.success) {
                                    this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                                    this.$router.push('/administracion/usuarios')

                                } else {
                                    this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                                }
                                this.hideLoading()
                            }).catch(error => {
                                this.hideLoading();
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Error inesperado'
                                });
                            });
                            this.showApprovedModal = false;
                        } else {
                            this.showApprovedModal = false;
                            this.$store.dispatch('notifications/warning', {msg: 'Complete los campos requeridos'}, {root: true});
                        }
                    })

                }
            },

            passwordRefresh() {
                this.$confirm('La contraseña de este usuario se restablecerá por: 1234567, ¿desea continuar?', 'Atención', {
                    confirmButtonText: 'Continuar',
                    type: 'warning',
                    center: true
                }).then(confirm => {
                    let _params = {
                        cryptId: this.$route.params.id
                    }
                    axios.post('/api/restore-password', _params).then(response => {
                        if (response.data.success) {
                            this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                        } else {
                            this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                        }
                    })
                }).catch(e => {

                });
            },

            checkIsLdap() {
                if (this.$route.params.id) {
                    this.showLoading();
                    let _params = {
                        ...this.userForm
                    }
                    axios.post('/api/check-is-ldap', _params).then(response => {
                        if (response.data.success) {
                            this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                        } else {
                            this.userForm.isLdap = false;
                            this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                        }
                        this.hideLoading();
                    }).catch(e => {
                        this.hideLoading();
                        this.userForm.isLdap = false;
                        console.log('checkIsldap', e)
                        this.$store.dispatch('notifications/error', {msg: 'Error inesperado'}, {root: true});
                    });
                }
            },

            checkUser(username, isLdap) {
                if (username) {
                    let data = {
                        username: username,
                        isLdap: isLdap
                    };

                    this.showLoading();

                    axios.post('/api/users/check-user', data).then(response => {
                        this.hideLoading();
                        if(!response.data.success){
                           this.$router.push('/administracion/usuarios')
                        }
                        this.$message({
                            type: response.data.success ? 'success' : 'error',
                            message: response.data.message
                        });

                    }).catch(error => {
                        this.userForm = {};
                        this.hideLoading();
                        this.$message({
                            type: 'error',
                            message: 'El usuario que ingresó no es válido o ya existe en el sistema, favor de verificar.'
                        });
                    });
                } else {
                    this.isUserValid = false;
                    this.$message({
                        type: 'error',
                        message: 'Ingrese un usuario válido'
                    });
                }
            },

            approvedAux(profile){
                this.showApprovedModal = true
                this.setUserRoles(profile);
            }


        }
    }
</script>

<style>
    .VuePassword__Meter {
        padding-left: -.5rem !important;
    }
</style>




